import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { GlobalContext } from "../context/GlobalContext";

function ProjectShort(props) {
    
    const {lang, getProject} = useContext(GlobalContext)

    const link = props.id.split(' ').join('_')
    console.log(props);

    const go = (id) => {
        getProject(id)
    }

    let divid = "short-" + props.id.split(" ").join("")

    return(
        <div className="projectShort" id={divid}>
            <p className="projectShort__description">{props.desc}</p>

            <Link to={link} onClick={() => go(props.id)}><button className="projectShort__button">{lang === "ingles" ? "SEE PROJECT" : "VER PROYECTO"}</button></Link>
        </div>
    )
}

export default ProjectShort